import {Component, OnInit} from '@angular/core';
import { LoginInfoComponent } from "../../user/login-info/login-info.component";
import { Response } from '@angular/http';
import 'rxjs/Rx';
import { ClientService } from "../../services/client.service";
import { ConfigService } from "../../utils/config.service";
import { AuthService } from "../../services/auth.service";
import { config } from '../../smartadmin.config';
@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
  ,
  styles: [
    '.active { color: white; }'
   
  ] 
})
export class NavigationComponent implements OnInit {
  client: any = {};
  user: any = {};
  skinDefaultName: string = 'qubesense-style-2-default';
  skin: any = {};
  navigationMenuBackColor: any = {};
  navigationMenuLabelColor: any = {};
  navigationSubMenuBackColor: any = {};
  navigationSubMenuLabelColor: any = {};

  constructor(private clientService: ClientService, private config: ConfigService, private authService: AuthService) {

    this.client = this.clientService.getClient();
    this.clientService.getUpdatedClient().subscribe(data => {
      this.client = data;

    });

    this.user = this.authService.getUser();
    this.authService.getUpdatedUser().subscribe(data => {
      this.user = data;

      });
  }

  ngOnInit() {
    this.client = this.clientService.getClient();
    this.skinDefaultName = this.client.clientSetting.siteSetting.baseTheme || 'qubesense-style-2-default';
    let skins = config.skins;
    var skinDefaultName2 = this.skinDefaultName.split(' ')[0];
    let skin = skins.find((_skin) => {
      return _skin.name == skinDefaultName2
    })
    this.navigationMenuBackColor = skin.navigationMenuBackColor;
    this.navigationMenuLabelColor = skin.navigationMenuLabelColor;
    this.navigationSubMenuBackColor = skin.navigationSubMenuBackColor;
    this.navigationSubMenuLabelColor = skin.navigationSubMenuLabelColor;
    //this.loginInfoLabelColor = skin.loginInfoLabelColor;
  }

  isMenuInRole(menu: any)
  {
    var returnBool = false;
    if (this.user == null) return true;
    if ((this.user.IsUserSystemAdmin != null && this.user.IsUserSystemAdmin) || (this.user.IsUserClientAdmin != null && this.user.IsUserClientAdmin))
      return true;
       
    if (menu != null && menu.roles != null && menu.roles.length > 0)
    {
      menu.roles.forEach(
        role => {

          var index = this.user.roles.indexOf(role.role);
          if (index > -1) {
            returnBool = true;
            return
          }

        }
      );

    }
    else
    {
        returnBool = true;
    }

    return returnBool;
  }

 

}
